// OWPML Namespace constants
export const NS = {
  // 한/글 문서 네임스페이스
  hh: 'http://www.hancom.co.kr/hwpml/2011/head',
  hp: 'http://www.hancom.co.kr/hwpml/2011/paragraph',
  hs: 'http://www.hancom.co.kr/hwpml/2011/section',
  hc: 'http://www.hancom.co.kr/hwpml/2011/core',
  ha: 'http://www.hancom.co.kr/hwpml/2011/app',
  // OPF / ODF
  opf: 'http://www.idpf.org/2007/opf',
  odf: 'urn:oasis:names:tc:opendocument:xmlns:container',
  // 미디어 타입
  mimeHwpx: 'application/hwp+zip',
} as const;
